import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';
import DeliveryCheckPrompt from './components/DeliveryCheckPrompt';
import './theme.css';
import { initTheme } from './theme';

initTheme();

// Only the iOS/Android apps need the shell glue (deep links, status bar, back
// button, external links); dynamic import keeps the Capacitor plugin code out
// of the website's critical path.
if (Capacitor.isNativePlatform()) {
  import('./nativeShell').then((m) => m.initNativeShell());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /><DeliveryCheckPrompt /></React.StrictMode>);
